module.exports = "<input  [(ngModel)]=\"input\" type=\"text\" [placeholder]=\"placeholder\">\r\n"